<template>
  <div>
    <label :for="sid" class="label">
      <template v-if="label">{{ typeof label == 'string' ? label : getTitle }}</template>
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>
    <v-select
      :class="{'is-invalid': this.model.$error}"
      :closeOnSelect="closeOnSelect"
      :disabled="disabled"
      :options="options"
      :value="localValues"
      :name="model.$form.testPath ? model.$path : undefined"
      :multiple="isModelAnArray"
      :searchable="taggable || customValue ? true : searchable"
      :placeholder="placeholder"
      :clearSearchOnSelect="taggable ? true : clearSearchOnSelect"
      :taggable="taggable"
      :autocomplete="autocomplete"
      @search:focus="focus"
      @search:blur="blur"
      @input="selectedValue"
    >
      <template name="no-options">
        <slot slot="no-options">
          <span>{{noOptionsText}}</span>
        </slot>
      </template>
    </v-select>
    <w-error :model="model"></w-error>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';

import vSelect from 'vue-select';
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'vue-select',
  components: {WError, WTooltip, vSelect},
  mixins: [modelMixin],
  props: {
    values: Array,
    label: {
      type: [String, Boolean],
      default: true
    },
    searchable: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    noOptionsText: {
      type: String,
      default: 'Przepraszamy, nie znaleziono pasującej opcji.'
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    mapObject: {
      type: Function,
      default: option => ({text: option.label, value: option.code})
    },
    objectValueProperty: {
      type: String,
      default: 'value'
    },
    customValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sid: 'ddw' + Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    isModelAnArray() {
      return this.model.$schema.type === 'array';
    },
    isModelAnObj() {
      return this.model.$schema.type === 'object';
    },
    isChildAnObject() {
      return this.model.$schema.itemType === 'object';
    },
    taggable() {
      return this.isModelAnArray;
    },
    options() {
      if (!this.values) return [];

      return this.values.map(item => {
        if (typeof item === 'object') {
          return {label: item.text || item.value, code: item.value};
        } else {
          return {label: item, code: item};
        }
      });
    },
    localValues() {
      let values = [];

      if (this.isModelAnObj) {
        values.push(this.svalue[this.objectValueProperty]);
      } else if (this.isModelAnArray) {
        if (this.isChildAnObject) {
          values = this.svalue.map(value => value[this.objectValueProperty]);
        } else {
          values = [...this.svalue];
        }
      } else {
        values.push(this.svalue);
      }

      return this.getOptionsByValues(values);
    }
  },
  methods: {
    // Blur na polu schemy
    blur() {
      this.$set(this.model, '$hasFocus', false);
    },
    // Focus na polu schemy
    focus() {
      this.$set(this.model, '$hasFocus', true);
    },

    getOptionsByValues(values) {
      let options = this.options.filter(x => values.some(y => y.toString() === x.code.toString()));
      if (!this.customValue || options.length === values.length) {
        return options;
      }

      values = values.filter(value => value && !options.some(option => option.code.toString() === value.toString())).map(value => ({code: value, label: value}));
      return options.concat(values);
    },

    // Emit z wybraną wartością
    selectedValue(values) {
      if (values == void 0) {
        values = [];
      }

      if (!Array.isArray(values)) {
        values = [values];
      }

      // w momencie gdy wpisujemy wartość z 'palca', nie dostaje ona property `code`
      for (let i = 0; i < values.length; i++) {
        values[i].code = values[i].code || values[i].label;
      }

      values = this.getOptionsByValues(values.map(value => value.code));

      if (this.isModelAnArray) {
        for (let i = this.model.$items.length - 1; i >= 0; i--) {
          this.model.$removeRow(i);
        }

        this.$emit('rowDeleted');

        for (let i = 0; i < values.length; i++) {
          if (this.isChildAnObject) {
            this.model.$addRow(this.mapObject(values[i]));
          } else {
            this.model.$addRow(values[i].code);
          }
        }

        this.$emit('rowAdded', values.length);
      } else if (this.isModelAnObj) {
        this.$set(this.model, '$value', this.mapObject(values[0]));
      } else {
        if (values.length) {
          this.$set(this.model, '$value', values[0].code + '');
        } else {
          this.$set(this.model, '$value', '');
        }
      }

      this.$emit('input', this.model.$value);
    }
  },
  mounted() {
    if (this.setTitleAsPlaceholder) {
      this.placeholder = this.getTitle;
      this.label = false;
    }
  }
};
</script>
<style>
button.vs__clear {
  margin-top: -5px;
}
</style>
